import { Component, OnInit, Input } from '@angular/core';
import { SubscriptionAlert } from '../../../interfaces/subscription';

@Component({
  selector: 'app-subscription-alerts',
  templateUrl: './subscription-alerts.component.html',
  styleUrls: ['./subscription-alerts.component.scss']
})
export class SubscriptionAlertsComponent implements OnInit {

  @Input() alert: SubscriptionAlert[];

  constructor() { }

  ngOnInit() {
  }

}
